






























































































import Loading from "vue-loading-overlay";
import { Component, Vue, Watch } from "vue-property-decorator";
import QFooter from "./qFooter.vue";
import QNav from "./qNav.vue";
import QSidebar from "./qSidebar.vue";
import QSidebarAadminCustomer from "./qSidebarAdminCustomer.vue";

import CustomerUser from "@/model/customerUser";
import User from "@/model/user";
import "flatpickr/dist/flatpickr.css";
import "vue-loading-overlay/dist/vue-loading.css";
import { namespace } from "vuex-class";

const authStore = namespace("Auth");

Vue.use(Loading);

@Component({
  name: "AdminLayout",
  components: {
    QFooter,
    QNav,
    QSidebar,
    QSidebarAadminCustomer,
    QScripts: () => import("@/common/qScripts.vue"),
  },
})
export default class AdminLayout extends Vue {
  public classPage: string[];
  public classToggle = [];
  // @Watch("$route", { immediate: true, deep: true })
  // onUrlChange(newValue: any, oldValue: any) {
  //   if (newValue && oldValue && newValue.name !== oldValue.name) {
  //     this.setImportTitle();
  //     this.changedRoute++;
  //   }
  // }
  @authStore.Getter
  public getUserType!: string;

  @authStore.Getter
  public getUserLogging!: User;

  @authStore.Getter
  public isCustomer!: boolean;

  @authStore.Getter
  public getCustomerUser!: CustomerUser;

  @authStore.Getter
  public isLoginTime!: boolean;

  @authStore.Action
  public updateIsLoginTime!: (isLoginTime: boolean) => void;

  @authStore.Action
  public fetchCurrentUser!: (user) => void;

  @authStore.Action
  public updateUserType!: (userType: string) => void;

  public changedRoute = 1;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public dynamicSubTitle = "";

  public userName = "";

  @Watch("$route.currentRoute", { deep: true, immediate: true })
  public changeCurrentRoute() {
    this.getClassPage();
  }

  public async getCurrentUser() {
    // const result = await userApi.me();
    // this.updateUserType(result.user_type);
    // // this.updateIsLoginTime(true);
    // await this.fetchCurrentUser(result.user_info);
  }

  get isLoading(): boolean {
    return true;
  }

  public getClassPage() {
    this.changedRoute; // hack to re-computed
    const initalClass = ["mb__admin mb__base-color-blue"];
    if (this.$router.currentRoute.meta.className) {
      initalClass.push(this.$router.currentRoute.meta.className);
    }
    this.classPage = initalClass;
  }

  get currentSiderbarComponent(): string {
    // if (this.getUserType && this.getUserType === ROLE_ADMIN) {
    return "QSidebar";
    // }
    // return "QSidebarAadminCustomer";
  }

  public reload() {
    const userPageName = ["admin.admin", "admin-customer.customers"];
    if (userPageName.includes(this.$route.name)) {
      location.reload();
    }
  }

  public closeMenu(event) {
    if (event.target && event.target._prevClass == "mb__admin-navarea") {
      const bodyNode = document.querySelector("body");
      const menuBarNode = document.querySelector("#menu_bar");
      bodyNode.classList.remove("open");
      menuBarNode.classList.remove("open");
    }
  }
}
